import { HStack, SegmentGroup, Text } from '@chakra-ui/react'

export type Placement = 'Home' | 'Work'

/** [O1] Home | Work for one hybrid-turf member. The system's suggestion is marked; it never auto-applies. */
export function PlacementControl({ name, value, suggested, canWork, onChange }: {
  name: string
  value: Placement
  suggested: Placement
  canWork: boolean
  onChange: (p: Placement) => void
}) {
  return (
    <HStack gap={2} wrap="wrap">
      <SegmentGroup.Root
        size="sm"
        colorPalette="brand"
        aria-label={`Visit ${name} at`}
        value={value}
        onValueChange={(e) => { if (e.value) onChange(e.value as Placement) }}
      >
        <SegmentGroup.Indicator />
        <SegmentGroup.Items items={[
          { value: 'Home', label: 'Home' },
          { value: 'Work', label: 'Work', disabled: !canWork },
        ]} />
      </SegmentGroup.Root>
      {suggested !== value && <Text fontSize="xs" color="fg.muted">Suggested: {suggested}</Text>}
    </HStack>
  )
}
